import React from 'react';
import { checkBirthdayPriority } from '../services/birthdayService';

const HeroBanner = ({ theme }) => {
  const bannerStyle = theme && theme.colors ? {
    background: `linear-gradient(135deg, ${theme.colors.primary}, ${theme.colors.secondary})`
  } : {};

  // Doğum günü kontrolü
  const birthdayCheck = checkBirthdayPriority();

  return (
    <div className="hero-banner" style={bannerStyle}>
      <div className="hero-content">
        {birthdayCheck.hasBirthday ? (
          <div className="hero-decoration">
            🎂 Bugün {birthdayCheck.birthdayStudent.name}'in doğum günü!
          </div>
        ) : (
          <>
            <div className="hero-icon">{theme?.icon || '🌟'}</div>
            <div className="hero-text">
              <h1 className="hero-title">{theme?.type === 'special' && theme.title ? theme.title : 'Sevgili Yıldızlarım'}</h1>
              <p className="hero-sub">
                {theme?.type === 'special' ? theme.message : 'Bugün davranışlarımızla da parlayalım. Her güzel davranış bir ışık yakar. ✨'}
              </p>
            </div>
            <div className="hero-decoration">📚</div>
          </>
        )}
      </div>
    </div>
  );
};

export default HeroBanner;